<template>

    <form-group :validator="v" :label="label" :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox-group :id="id" v-model="selected"
                stacked
                v-bind="attrs"
                :state="v.$dirty ? !v.$error : null"
                :options="options"
                :disabled="readonly"
                v-on="listeners">
            </b-form-checkbox-group>
        </template>
    </form-group>
    
</template>

<script>
import _ from "lodash"

export default {

    props: {
        value: [Array],
        v: [Object],
        label: [String],
        tip: [String],
        options: [Array],
        readonly: {
          "type": Boolean,
          default: false
        }
    },
    computed: {
        id() {
            return _.uniqueId('checkbox')
        },
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }   
    }
}
</script>